import { put, call, takeLatest } from "redux-saga/effects";
import { APIClient } from "../../../helpers/api_helper";
import { forgetPasswordError, forgetPasswordSuccess } from "./actions";
import { FORGET_PASSWORD } from "./actionTypes";
const api = new APIClient();

function* forgetPassword({ payload: { user } }) {
  const forgetUrl = `${process.env.REACT_APP_API_BASE_URL}/admin/forgot-password`;

  try {
    const forget = () =>
      api.create(forgetUrl, {
        email: user.email,
      });

    const response = yield call(forget);

    if (response && response.status_code === 200) {
      yield put(forgetPasswordSuccess());
    } else {
      yield put(forgetPasswordError(response?.message));
    }
  } catch (error) {
    yield put(forgetPasswordError(error.message));
  }
}

function* forgetPasswordSaga() {
  yield takeLatest(FORGET_PASSWORD, forgetPassword);
}

export default forgetPasswordSaga;
